// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 572 ? "polySeg" : chunkId) + "." + {"224":"702f7d0a15ed09b09884","463":"ef0067a1fd765dd93ed1","572":"cf6e42b48550f0238883","856":"7c5b9e3c66758bd4bbf2","996":"8496c53040e5761053ab"}[chunkId] + ".js";
};